import { RouteLocationNormalized } from 'vue-router'
import { useNativeScanStore } from '@/storage/nativeScan'
import { useUserLogin } from '@/storage/userLogin'
import { storeToRefs } from 'pinia'
import { useUserPositionStore } from '@/storage/userPosition'
import { useSiteStore } from '@/storage/site'
import { useUserStore } from '@/storage/user'
import { postLocation } from '@/services/api/locationRequested'

export const positionResolver = async (to: RouteLocationNormalized) => {
  if (!to.meta.requiresLocation) {
    return true
  }

  const { isVisitor } = storeToRefs(useUserLogin())
  const { selectionConfirmed } = storeToRefs(useSiteStore())
  const { isContractor } = storeToRefs(useUserStore())

  const visitorScanIn = isVisitor.value && useNativeScanStore().uuid
  const visitorNotScanIn = isVisitor.value && !useNativeScanStore().uuid
  const visitorPreciseLocationRequired =
    visitorNotScanIn && to.name === 'selectNearbySite'
  const preciseLocationRequired =
    visitorPreciseLocationRequired || isContractor.value

  try {
    const { setUserPosition, setPositionErrorMessage } = useUserPositionStore()
    const { position } = storeToRefs(useUserPositionStore())

    await setUserPosition()

    if (position.value.accuracy > 250) {
      postLocation({ location: position.value }).then()
    }

    if (preciseLocationRequired && position.value.accuracy > 250) {
      setPositionErrorMessage([
        'Location permission denied.',
        'Please turn on location services in your settings.',
      ])
      return { name: 'helpLocationPermission' }
    }
    return true
  } catch {
    if (visitorScanIn || (visitorNotScanIn && selectionConfirmed.value)) {
      return true
    }

    return { name: 'helpLocationPermission' }
  }
}
